export function CutLine() {
  return (
    <div className="relative my-4 flex items-center">
      <div className="flex-1 border-t-2 border-dashed border-zone-cutline/60" />
      <span className="mx-4 px-3 py-1 rounded-full bg-zone-cutline/10 text-zone-cutline text-xs font-bold uppercase tracking-wider whitespace-nowrap">
        Auto-Qualifier Line (Rank 48)
      </span>
      <div className="flex-1 border-t-2 border-dashed border-zone-cutline/60" />
    </div>
  )
}
